import { Sliders } from "@/icons/Sliders.tsx";
import { ActionIcon, Affix, Drawer } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ReactNode, useEffect } from "react";

export function MobileView({
  sideBar,
  mainContent,
  generating = false,
}: {
  sideBar: ReactNode;
  mainContent: ReactNode;
  generating: boolean;
}) {
  const [opened, { close, toggle }] = useDisclosure(false);

  useEffect(() => {
    if (generating && opened) {
      close();
    }
  }, [generating]);

  return (
    <>
      {mainContent}
      <Drawer
        size="85%"
        position="bottom"
        opened={opened}
        onClose={close}
        withCloseButton={false}
      >
        {sideBar}
      </Drawer>
      <Affix position={{ bottom: 20, right: 20 }}>
        <ActionIcon
          onClick={toggle}
          radius={50}
          size={50}
          variant="filled"
          color="grape"
          aria-label="Settings"
        >
          <Sliders size={22} />
        </ActionIcon>
      </Affix>
    </>
  );
}
